<template>
  <v-col>
    <v-toolbar flat>
      <v-toolbar-title>
        valide User: {{ validUsers.length }}/{{ form.length }}
      </v-toolbar-title>
    </v-toolbar>

    <v-data-table
      id="virtual-scroll-table"
      :headers="headers"
      :items="form"
      class="elevation-1"
      fixed-header
      dense
      disable-pagination
      hide-default-footer
      height="600px"
    >
      <template #item="{ item }">
        <v-lazy tag="tr" style="height: 25px">
          <div style="display: contents">
            <td v-for="header of headers" :key="header.value" class="text-left px-1">
              <v-select
                v-if="header.value === 'branch_id'"
                v-model="item[header.value]"
                :label="header.text"
                single-line
                :items="getBranchItems"
              >
                <template #selection="{ item: display }">
                  <span>
                    {{ display.text.split("|")[0] }}
                  </span>
                </template>
              </v-select>
              <v-text-field
                v-else
                v-model="item[header.value]"
                :label="header.text"
                single-line
              />
            </td>
          </div>
        </v-lazy>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
export default {
   name: 'CompanyUsers',
   inject: ['branchItems'],
   model: {
      prop: 'form',
      event: 'update:form',
   },
   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Array,
         required: true,
      },
   },

   data () {
      return {
         headers: [
            { text: 'Vorname *', value: 'firstname', width: '11%' },
            { text: 'Nachname *', value: 'lastname', width: '11%' },
            { text: 'Benutzername *', value: 'username', width: '11%' },
            { text: 'Passwort', value: 'password', width: '11%' },
            { text: 'Standort *', value: 'branch_id', width: '15%' },
            { text: 'Jobtitel', value: 'jobtitle', width: '15%' },
            { text: 'E-Mail *', value: 'email', width: '15%' },
            { text: 'Telefon', value: 'telephone', width: '11%' },
         ],
      }
   },
   computed: {
      getBranchItems () {
         return this.branchItems()
      },

      validUsers () {
         return this.form.filter((user) => {
            return (
               user.firstname &&
                user.lastname &&
                user.username &&
                user.branch_id &&
                user.email
            )
         })
      },
   },
}
</script>

<style>

</style>
